import React from 'react';

export const ForgeK15tScrollSitesSearchResultIcon = () => {
	return (
		<svg
			viewBox="0 0 144 144"
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			aria-hidden="true"
			focusable="false"
		>
			<path
				d="M115.9,13.3c1.8,0,3.5,1,4.3,2.7c1-0.8,2.6-0.5,3.3,0.7c0.3,0.4,0.4,0.9,0.4,1.2c1.7,0.2,3.1,1.6,3.3,3.3v0.3
					c0,1.5-1.7,3-3.7,3h-10.9c-2.1,0-3.7-1.5-3.7-3v-0.3c0.1-1.4,1-2.6,2.4-3.2V18C111.3,15.4,113.4,13.3,115.9,13.3L115.9,13.3"
				fill="#FF8300"
			/>
			<path
				d="M75,130.4h-9.6c-14.9,0-27.1-10.8-27.1-23.9V29.3c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9v77.2
					c0,7.8,7.7,14.2,17.3,14.2h9.5c9.6,0,17.3-6.4,17.3-14.2V89c0.1-2.7,2.4-4.8,5.1-4.7c2.6,0.1,4.6,2.1,4.7,4.7v17.6
					C102,119.7,89.9,130.4,75,130.4z"
				fill="#58595B"
			/>
			<path
				d="M71.5,18.6c2.8,0,5.4,1.6,6.5,4.2c0.6-0.4,1.3-0.7,2-0.7c1.9,0,3.5,1.5,3.6,3.5c2.7,0.3,4.8,2.5,5,5.1v0.5
					c0,2.3-2.5,4.7-5.7,4.7H66.3c-3.1,0-5.7-2.4-5.7-4.7v-0.5c0.1-2.2,1.5-4.1,3.6-4.9c0-0.1,0-0.1,0-0.2C64.3,21.7,67.5,18.6,71.5,18.6
					L71.5,18.6"
				fill="#FF8300"
			/>
			<g>
				<path
					d="M89.8,66.2c-0.5,0-1.1-0.2-1.5-0.6l-6-5.9c-0.4-0.4-0.7-1-0.7-1.6s0.3-1.2,0.7-1.6l6-5.4
						c0.9-0.8,2.3-0.7,3.1,0.2c0.8,0.9,0.7,2.3-0.2,3.1L87,58.2l4.3,4.3c0.9,0.9,0.9,2.2,0,3.1C91,66,90.4,66.2,89.8,66.2z"
					fill="#FF8300"
				/>
				<path
					d="M104.8,66.2c-0.6,0-1.1-0.2-1.6-0.7c-0.9-0.9-0.9-2.2,0-3.1l4.3-4.3l-4.3-3.8c-0.9-0.8-1-2.2-0.2-3.1
						c0.8-0.9,2.2-1,3.1-0.2l6,5.4c0.4,0.4,0.7,1,0.7,1.6s-0.2,1.2-0.7,1.6l-6,5.9C105.9,66,105.3,66.2,104.8,66.2z"
					fill="#FF8300"
				/>
				<path
					d="M95,69.7c-0.2,0-0.4,0-0.5-0.1c-1.2-0.3-1.9-1.5-1.6-2.7l4.8-18.5c0.3-1.2,1.5-1.9,2.7-1.6
						c1.2,0.3,1.9,1.5,1.6,2.7L97.1,68C96.9,69.1,96,69.7,95,69.7z"
					fill="#FF8300"
				/>
			</g>
		</svg>
	);
};
